import React from 'react';
import { Outlet } from 'react-router-dom';
import SiteHeader from '../../components/site/SiteHeader';
import SiteFooter from '../../components/site/SiteFooter';
import CookiePreferencesPopup from '../../components/CookiePreferencesPopup';

/**
 * Chrome for the rebuilt marketing site: the grey mega-menu header, the
 * page body, and the full sitemap footer.
 */
const SiteLayout = () => (
  <div className="flex min-h-screen flex-col bg-white">
    <div className="sticky top-0 z-50">
      <SiteHeader />
    </div>
    <main className="flex-1">
      <Outlet />
    </main>
    <SiteFooter />
    <CookiePreferencesPopup />
  </div>
);

export default SiteLayout;
